// import { NavLink } from "react-router-dom";
import "../Style/Menu.css"
import Logo from "../Component/Logo"

export default function Menu2(props) {

    return (
        <div className="menu">
            
            <Logo></Logo>
            <h1>Train Load Viewer</h1>
            {<props.lineTitle></props.lineTitle>}

        </div>

    )
}
